<script setup lang="ts">
import './modal.scss'
import { Icon } from '@iconify/vue'
import { computed } from 'vue'

interface Props {
  show: boolean,
  title?: string,
}

const props = defineProps<Props>()
const emit = defineEmits(['on:close'])

const display = computed(() => {
  return props.show
})

const handleClose = () => {
  emit('on:close', false)
}

</script>

<template>
  <div class="cs-modal" v-if="display">
    <div class="cs-modal__content">
      <div class="cs-modal__heading" v-if="props.title">
        <h3>{{props.title}}</h3>
        <div class="actions">
          <div class="close" @click="handleClose">
            <Icon icon="material-symbols-light:close" />
          </div>
        </div>
      </div>
      <div class="cs-modal__body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

</style>
